import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import BatteryBackupPage from "./components/BatteryBackupPage";
import HomePageOneApp from "./components/HomePageOneApp";
import HomePage from "./components/HomePage";
import ServiceOutagePage from "./components/ServiceOutagePage";
import NetworkFeedback from './components/NetworkOutage/NetworkFeedback/NetworkFeedback';
import ContactUsPage from "./components/ContactUsPage";
import ContactUsCallMePage from "./components/ContactUsCallMePage";
import EquipmentReturnPage from "./components/EquipmentReturnPage";
import HomeOneAppSubsequent from './components/modules/HomeOneAppSubsequent';
import ContactusOneApp from"./components/ContactUsPageOneApp";
import ContactUsCallMePageOneAPP from "./components/ContactUsCallMePageOneApp";
import { Route, BrowserRouter as Router } from "react-router-dom";
import EquipmentReturnPageOneApp from "./components/EquipmentReturnPageOneApp";
// import '../src/data/CombinedDatas';
import "./index.css";
import ContactUsSpinner from "./components/ContactUsSpinner";
import EquipmentReturnPDF from "./components/modules/EquipmentReturnPDF";

// To suppor the ES6 ployfills for IE browser
  const ES5Script = document.createElement("script");
  ES5Script.src =
    "https://cdnjs.cloudflare.com/ajax/libs/es5-shim/4.5.7/es5-shim.min.js";
  ES5Script.async = true;
  document.body.appendChild(ES5Script);
  const ES6Script = document.createElement("script");
  ES6Script.src =
    "https://cdnjs.cloudflare.com/ajax/libs/es6-shim/0.34.2/es6-shim.min.js";
  ES6Script.async = true;
  document.body.appendChild(ES6Script);

if(typeof(window._satellite)!='undefined'){window._satellite.pageBottom();}

 //window.domain_url= "residential"
 //window.oneAppFlag = true;
 if(document.cookie.includes("oneV") === true && !document.cookie.includes("userinfo")) {
  let currentLocation = window.location.href
  let host =  window.location.protocol+ "//"+ window.location.host +"/consumer/myverizon/router?target="+window.encodeURIComponent(currentLocation);
  window.location.href = host
}
if(window.domain_url.toLowerCase() === "consumer") {
  ReactDOM.render(
    <Router>
      <div>
        {/* For consumer pages */}
        <Route
          exact
          path="/support/consumer/home"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
              <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />
      
        <Route
        exact
        path="/support/consumer/homeoneappsubsequent"
        render={() => (
            <HomeOneAppSubsequent
            NeedMoreSupportData={window.homePageData}
            TabData={window.homePageData.tablist[0].tablist}
            />
        )}
        />

        <Route
          exact
          path="/support/consumer/account"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

        <Route
          exact
          path="/support/consumer/tv"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

      <Route
          exact
          path="/support/consumer/homephone"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

        <Route
          exact
          path="/support/consumer/internet"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

        <Route
          exact
          path="/support/consumer/contactus"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
               <ContactusOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ globalSessionID={
                window.globalSessionID
              }
              ContactData={window.contactUsData}
              DynamicData={window.contactUsDynamicData}
              ECRMData={window.ecrmData}
            />
            )
            :
            (
              <ContactUsPage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ globalSessionID={
                window.globalSessionID
              }
              ContactData={window.contactUsData}
              DynamicData={window.contactUsDynamicData}
              ECRMData={window.ecrmData}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

          <Route
          exact
          path="/support/consumer/contactus/callme"
          render={() => (
            <ContactUsCallMePageOneAPP
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ globalSessionID={
                window.globalSessionID
              }
              ContactData={window.contactUsData}
              DynamicData={window.contactUsDynamicData}
              ECRMData={window.ecrmData}
            />
          )}
        />

    <Route path="/support/consumer/serviceoutage" 
        render={() => {
          let isSignInUser = (document.cookie.indexOf('userinfo') > -1) ? true : false;
            //  isSignInUser = true;
          if(window.uiType && window.uiType.toLowerCase()==='new'&& isSignInUser){
            return <NetworkFeedback outageStaticData={window.soPageData} outageDynamicData={window.soDynamicData} AlertBanner={window.staticBannerContent}/>
          }else{
            return <ServiceOutagePage /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ 
            OutageData={window.soPageData} 
            DynamicData={window.soDynamicData} 
            AlertBanner={window.staticBannerContent} />
          }
        }} />
        
        <Route
          path="/support/consumer/battery-backup"
          render={() => (
            <BatteryBackupPage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ BBUPageJSON={
                window.bbuPageData
              }
              DynamicData={window.bbuDynamicData}
              AlertBanner={window.staticBannerContent}
            />
          )}
        />

      <Route
          path="/support/consumer/equipment-return"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
            <EquipmentReturnPageOneApp
            />
            )
            :
            (
              <EquipmentReturnPage
              EquipmentReturnData={JSON.parse(window.erStaticData)}
              StaticData={JSON.parse(window.erStaticData)}
              DynamicData={window.erDynamicData}
              NcogData = {window.ncogData}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

      <Route
          exact
          path="/support/consumer/EquipmentReturnPDF"
          render={() => (
              <EquipmentReturnPDF
              />
          )}
        />
        
{/* Support service consumer pages */}
            
        <Route
          path="/supportservices/consumer/home"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
              window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={
                window.hpInitResp.a_s
              } /*headerContentScript={window.headerContentScript}*/
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

      <Route
          exact
          path="/supportservices/consumer/account"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
              window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

        <Route
          exact
          path="/supportservices/consumer/tv"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
              window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

      <Route
          exact
          path="/supportservices/consumer/homephone"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
              window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

      <Route
          exact
          path="/supportservices/consumer/internet"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
              window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />


        <Route
        exact
          path="/supportservices/consumer/contactus/callme"
          render={() => (
            <ContactUsCallMePageOneAPP
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ globalSessionID={
                window.globalSessionID
              }
              ContactData={window.contactUsData}
              DynamicData={window.contactUsDynamicData}
              ECRMData={window.ecrmData}
            />
          )}
        />

        <Route path="/supportservices/consumer/serviceoutage" 
        render={() => {
          let isSignInUser = (document.cookie.indexOf('userinfo') > -1) ? true : false;
            //  isSignInUser = true;
          if(window.uiType && window.uiType.toLowerCase()==='new'&& isSignInUser){
            return <NetworkFeedback outageStaticData={window.soPageData} outageDynamicData={window.soDynamicData} AlertBanner={window.staticBannerContent} />
          }else{
            return <ServiceOutagePage /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ 
            OutageData={window.soPageData} 
            DynamicData={window.soDynamicData} 
            AlertBanner={window.staticBannerContent} />
          }
        }} />

      <Route
          path="/supportservices/consumer/battery-backup"
          render={() => (
            <BatteryBackupPage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ BBUPageJSON={
                window.bbuPageData
              }
              DynamicData={window.bbuDynamicData}
              AlertBanner={window.staticBannerContent}
            />
          )}
        />  

        <Route
          path="/supportservices/consumer/equipment-return"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
            <EquipmentReturnPageOneApp
            />
            )
            :
            (
            <EquipmentReturnPage
              EquipmentReturnData={JSON.parse(window.erStaticData)}
              StaticData={JSON.parse(window.erStaticData)}
              DynamicData={window.erDynamicData}
              NcogData = {window.ncogData}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

      <Route
          exact
          path="/supportservices/consumer/EquipmentReturnPDF"
          render={() => (
              <EquipmentReturnPDF
              />
          )}
        />
    </div>
  </Router>, document.getElementById('root')
  )
}


if(window.domain_url.toLowerCase() === "residential") {
ReactDOM.render(
  <Router>
    <div>
        <Route
          exact
          path="/support/residential/home"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
              <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

        <Route
          exact
          path="/support/residential/homeoneappsubsequent"
          render={() => (
              <HomeOneAppSubsequent
              NeedMoreSupportData={window.homePageData}
              TabData={window.homePageData.tablist[0].tablist}
              />
          )}
        />

        <Route
          exact
          path="/support/residential/account"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />
       
         <Route
          exact
          path="/support/residential/tv"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />
        
          <Route
          exact
          path="/support/residential/homephone"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

       
        <Route
          exact
          path="/support/residential/internet"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
              window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

        <Route
          exact
          path="/support/residential/contact-us"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <ContactUsSpinner></ContactUsSpinner>
            )
            :
            (
              <ContactUsPage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ globalSessionID={
                window.globalSessionID
              }
              ContactData={window.contactUsData}
              DynamicData={window.contactUsDynamicData}
              ECRMData={window.ecrmData}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />
        <Route
          exact
          path="/support/residential/contact-us/contactuslanding.htm"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <ContactUsSpinner></ContactUsSpinner>
            )
            :
            (
              <ContactUsPage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ globalSessionID={
                window.globalSessionID
              }
              ContactData={window.contactUsData}
              DynamicData={window.contactUsDynamicData}
              ECRMData={window.ecrmData}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />
         <Route
          exact
          path="support/residential/contact-us/contactuslanding.htm?src=FiosOnly"
          render={() => (
            <ContactUsSpinner></ContactUsSpinner>
          )}
        />
         <Route
          exact
          path="/support/residential/contact-us/contactuslanding.htm&src=FioSTroubleshooting"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <ContactUsSpinner></ContactUsSpinner>
            )
            :
            (
              <ContactUsPage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ globalSessionID={
                window.globalSessionID
              }
              ContactData={window.contactUsData}
              DynamicData={window.contactUsDynamicData}
              ECRMData={window.ecrmData}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />
        <Route
          exact
          path="/support/residential/contact-us/callme.htm"
          render={() => (
            <ContactUsCallMePageOneAPP
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ globalSessionID={
                window.globalSessionID
              }
              ContactData={window.contactUsData}
              DynamicData={window.contactUsDynamicData}
              ECRMData={window.ecrmData}
            />
          )}
        />

      <Route path="/support/residential/serviceoutage" 
        render={() => {
          let isSignInUser = (document.cookie.indexOf('userinfo') > -1) ? true : false;
            //  isSignInUser = true;
          if(window.uiType && window.uiType.toLowerCase()==='new'&& isSignInUser){
            return <NetworkFeedback outageStaticData={window.soPageData} outageDynamicData={window.soDynamicData} AlertBanner={window.staticBannerContent} />
          }else{
            return <ServiceOutagePage /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ 
            OutageData={window.soPageData} 
            DynamicData={window.soDynamicData}
            AlertBanner={window.staticBannerContent} />
          }
        }} />

        <Route path="/support/residential/service-outage" 
        render={() => {
          let isSignInUser = (document.cookie.indexOf('userinfo') > -1) ? true : false;
            //  isSignInUser = true;
          if(window.uiType && window.uiType.toLowerCase()==='new'&& isSignInUser){
            return <NetworkFeedback outageStaticData={window.soPageData} outageDynamicData={window.soDynamicData} AlertBanner={window.staticBannerContent} />
          }else{
            return <ServiceOutagePage /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ 
            OutageData={window.soPageData} 
            DynamicData={window.soDynamicData}
            AlertBanner={window.staticBannerContent} />
          }
        }} />

       <Route
          path="/support/residential/battery-backup"
          render={() => (
            <BatteryBackupPage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ BBUPageJSON={
                window.bbuPageData
              }
              DynamicData={window.bbuDynamicData}
              AlertBanner={window.staticBannerContent}
            />
          )}
        />

        <Route
          path="/support/residential/equipment-return"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
            <EquipmentReturnPageOneApp
             EquipmentReturnData={JSON.parse(window.erStaticData)}
             StaticData={JSON.parse(window.erStaticData)}
             DynamicData={window.erDynamicData}
             NcogData = {window.ncogData}
            />
            )
            :
            (
            <EquipmentReturnPage
              EquipmentReturnData={JSON.parse(window.erStaticData)}
              StaticData={JSON.parse(window.erStaticData)}
              DynamicData={window.erDynamicData}
              NcogData = {window.ncogData}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

      <Route
          exact
          path="/support/residential/EquipmentReturnPDF"
          render={() => (
              <EquipmentReturnPDF
              />
          )}
        />
		
		<Route
          path="/support/residential/equipmentreturn"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
            <EquipmentReturnPageOneApp
            />
            )
            :
            (
            <EquipmentReturnPage
              EquipmentReturnData={JSON.parse(window.erStaticData)}
              StaticData={JSON.parse(window.erStaticData)}
              DynamicData={window.erDynamicData}
              NcogData = {window.ncogData}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />
  {/* Support services residential */}
        <Route
          path="/supportservices/residential/home"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
              window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={
                window.hpInitResp.a_s
              } /*headerContentScript={window.headerContentScript}*/
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />
       
          <Route
          exact
          path="/supportservices/residential/account"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
              window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />
       
          <Route
          exact
          path="/supportservices/residential/tv"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
              window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />
        
          <Route
          exact
          path="/supportservices/residential/homephone"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
              window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

         
         <Route
          exact
          path="/supportservices/residential/internet"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
              <HomePageOneApp
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
              window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
            />
            )
            :
            (
            <HomePage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ NeedMoreSupportData={
                window.homePageData
              }
              TabData={window.homePageData.tablist[0].tablist}
              Title={window.homePageData.collist}
              Banner={window.homePageData.banner[0]}
              DynamicData={window.homePageDynamicData}
              AvailableDevices={window.hpInitResp.a_s}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />

      <Route
      exact
          path="/supportservices/residential/contact-us"
          render={() => (
            <ContactUsPage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ globalSessionID={
                window.globalSessionID
              }
              ContactData={window.contactUsData}
              DynamicData={window.contactUsDynamicData}
              ECRMData={window.ecrmData}
              AlertBanner={window.staticBannerContent}
            />
          )}
        />
        <Route
      exact
          path="/supportservices/residential/contact-us/contactuslanding.htm"
          render={() => (
            <ContactUsPage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ globalSessionID={
                window.globalSessionID
              }
              ContactData={window.contactUsData}
              DynamicData={window.contactUsDynamicData}
              ECRMData={window.ecrmData}
              AlertBanner={window.staticBannerContent}
            />
          )}
        />

        <Route
        exact
          path="/supportservices/residential/contact-us/callme.htm"
          render={() => (
            <ContactUsCallMePageOneAPP
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ globalSessionID={
                window.globalSessionID
              }
              ContactData={window.contactUsData}
              DynamicData={window.contactUsDynamicData}
              ECRMData={window.ecrmData}
            />
          )}
        />
     
        <Route path="/supportservices/residential/serviceoutage" 
        render={() => {
          let isSignInUser = (document.cookie.indexOf('userinfo') > -1) ? true : false;
            //  isSignInUser = true;
          if(window.uiType && window.uiType.toLowerCase()==='new'&& isSignInUser){
            return <NetworkFeedback outageStaticData={window.soPageData} outageDynamicData={window.soDynamicData} AlertBanner={window.staticBannerContent} />
          }else{
            return <ServiceOutagePage /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ 
            OutageData={window.soPageData} 
            DynamicData={window.soDynamicData}
            AlertBanner={window.staticBannerContent} />
          }
        }} />

      <Route path="/supportservices/residential/service-outage" 
        render={() => {
          let isSignInUser = (document.cookie.indexOf('userinfo') > -1) ? true : false;
            //  isSignInUser = true;
          if(window.uiType && window.uiType.toLowerCase()==='new'&& isSignInUser){
            return <NetworkFeedback outageStaticData={window.soPageData} outageDynamicData={window.soDynamicData} AlertBanner={window.staticBannerContent} />
          }else{
            return <ServiceOutagePage /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ 
            OutageData={window.soPageData} 
            DynamicData={window.soDynamicData}
            AlertBanner={window.staticBannerContent} />
          }
        }} />

      <Route
          path="/supportservices/residential/battery-backup"
          render={() => (
            <BatteryBackupPage
              /*HeaderContent={window.headerContent} FooterContent={window.footerContent}*/ BBUPageJSON={
                window.bbuPageData
              }
              DynamicData={window.bbuDynamicData}
              AlertBanner={window.staticBannerContent}
            />
          )}
        />

        <Route
          path="/supportservices/residential/equipment-return"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
            <EquipmentReturnPageOneApp
            />
            )
            :
            (
            <EquipmentReturnPage
              EquipmentReturnData={JSON.parse(window.erStaticData)}
              StaticData={JSON.parse(window.erStaticData)}
              DynamicData={window.erDynamicData}
              NcogData = {window.ncogData}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />
		  <Route
          exact
          path="/supportservices/residential/EquipmentReturnPDF"
          render={() => (
              <EquipmentReturnPDF
              />
          )}
        />

		  <Route
          path="/supportservices/residential/equipmentreturn"
          render={() => (
            (window.oneAppFlag == true && window.oneAppFlag != null) ?
            (
            <EquipmentReturnPageOneApp
            />
            )
            :
            (
            <EquipmentReturnPage
              EquipmentReturnData={JSON.parse(window.erStaticData)}
              StaticData={JSON.parse(window.erStaticData)}
              DynamicData={window.erDynamicData}
              NcogData = {window.ncogData}
              AlertBanner={window.staticBannerContent}
            />
            )
          )}
        />
      </div>
    </Router>
  , document.getElementById('root')
);
}



// WEBPACK FOOTER //
// ./src/index.js


// WEBPACK FOOTER //
// ./src/index.js